import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { offsetTypes } from '../../../../../../../../../../shared/core/shared.selectors';
import { takeUntil } from 'rxjs/operators';
import { DailyReportService } from '../../../../daily-report.service';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';

@Component({
    selector: 'app-station',
    templateUrl: './station.component.html',
    styleUrls: ['./station.component.scss'],
    standalone: false
})
export class StationComponent implements OnInit, OnDestroy {
  errorMessages: any = {};
  errorMessageMap = {
    comment: {
      required: 'This field is required.',
    },
    quantity: {
      required: 'This field is required.',
    },
  };
  fields: any = [];
  stationFormFields: any = [];
  stationForm: FormGroup = new FormGroup({});
  parentForm: any;
  offsetTypeOptions: any = [];
  timeBlockFields: any = [];
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private dailyReportService: DailyReportService,
    public dialogRef: MatDialogRef<StationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }

  ngOnInit() {
    this.parentForm = this.data?.form;
    this.stationFormFields = this.data?.stationFormFields || [];
    this.timeBlockFields = this.data?.timeBlockFields || [];

    this.stationFormFields.forEach(o => {
      this.stationForm?.addControl(
        o?.name,
        new FormControl({ value: null, disabled: !!o?.display_only },
          o?.is_optional === false ? [Validators.required] : [],
        ),
      );

      this.errorMessageMap[o.name] = {
        required: 'This field is required.',
      };

    });

    this.store.select(offsetTypes)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.offsetTypeOptions = data;
      });
  }


  close() {
    this.dialogRef.close();
  }


  add(): void {
    if (this.stationForm.invalid) {
      this.checkForErrors();
      return;
    }

    if (!this.parentForm) {
      return;
    }

    let index = 1;
    let lineKey = `line_${index}`;
    while (this.parentForm.contains(lineKey)) {
      index++;
      lineKey = `line_${index}`;
    }

    const stationFormValues = this.stationForm.getRawValue();
    const newLineGroup = new FormGroup({});

    Object.entries(stationFormValues).forEach(([key, value]) => {
      newLineGroup.addControl(key, new FormControl(value));
    });

    this.parentForm.addControl(lineKey, newLineGroup);
    const lineForm = this.parentForm.get(lineKey) as FormGroup;

    const now = new Date();
    const timeKey = `time_${now.getTime()}`;
    const newTimeGroup = new FormGroup({});
    let timeValue = '';

    this.timeBlockFields.forEach((field: any) => {
      const isDisabled = !!field?.display_only;
      const isRequired = field?.is_optional === false;
      const validators = isRequired ? [Validators.required] : null;

      const controlValue = field.name === 'time' ? this.formatTimeToAMPM(now) : null;

      timeValue = this.formatTimeToAMPM(now);

      newTimeGroup.addControl(
        field.name,
        new FormControl({ value: controlValue, disabled: isDisabled }, validators),
      );
    });

    // tslint:disable-next-line:variable-name
    let am_pm = '';
    let timePeriod = '';

    if (timeValue) {
      const [timePart, meridian] = timeValue.split(' ');
      timePeriod = timePart;
      am_pm = meridian;
    }

    newTimeGroup.addControl(
      'timePeriod',
      new FormControl({ value: timePeriod, disabled: false }),
    );

    newTimeGroup.addControl(
      'am_pm',
      new FormControl({ value: am_pm, disabled: false }),
    );

    lineForm.addControl(timeKey, newTimeGroup);

    this.dailyReportService.stationAdded.next(lineKey);
    this.stationForm.reset();
    this.close();
  }

  formatTimeToAMPM(date: Date): string {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12;

    const hoursStr = hours < 10 ? '0' + hours : hours;
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;

    return `${hoursStr}:${minutesStr} ${ampm}`;
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.stationForm, this.errorMessageMap, currentField)),
    };
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
